import React from 'react';

function Spacer() {
    return (
        <div className="spacer" />
    );
}

export default Spacer;